module.exports = fox._r("fonts/icomoon.eot", __webpack_public_path__ + "fonts/NGOgU-z.eot");


//////////////////
// WEBPACK FOOTER
// ./fonts/icomoon.eot
// module id = 37
// module chunks = 0